import cx from 'classnames';
import type { FunctionComponent } from 'react';
import useCallToAction from './useCallToAction';
import styles from './CallToAction.module.less';

type Props = {
  //  Traditionally our CTAs use a Bootstrap fadeInUp animation, this prop can disable that.
  shouldDisableAnimation?: boolean;
  //  Traditionally our CTAs have a bottom border, but in moving to Subnav everywhere we want to get rid of this.
  shouldHideBottomBorder?: boolean;
  // Traditionally our CTAs position their text at the bottom of the container,
  // but in some cases we want to add custom padding around the text.
  // This prop removes all default padding and allows the consumer to provide their own around the child elements.
  noPadding?: boolean;
};

/**
 * CallToAction is the section at the top of the app which is
 * immediately below the main nav. It can contain any content,
 * and usually contains a sub-nav (such as in Issues or a Project page).
 *
 * This is intended to replace the `setNavState` pattern where
 * we pass a Subnav component to Redux, instead letting whatever
 * page be responsible for rendering its own call to action.
 */
const CallToAction: FunctionComponent<Props> = ({
  children,
  shouldDisableAnimation,
  shouldHideBottomBorder,
  noPadding,
}) => {
  useCallToAction();
  return (
    <div
      className={cx(styles.cta, {
        [styles.ctaNoBorder]: shouldHideBottomBorder,
        [styles.ctaNoPadding]: noPadding,
      })}
    >
      <div
        className={cx('container container-responsive', {
          'animated fast fadeInUp': !shouldDisableAnimation,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default CallToAction;
